var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top-image"
  }, [_c('div', {
    staticClass: "top-image__bg",
    style: 'background-image: url(' + _vm.bgImage + ')'
  }), _c('div', {
    staticClass: "top-image__inner"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-30 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.image,
      "max-width": "586",
      "width": "100%"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7",
      "lg": "6",
      "offset-lg": "1"
    }
  }, [_c('div', {
    staticClass: "pt-md-20 pt-lg-60"
  }, [_c('h3', {
    staticClass: "tit top-line-tit mb-16 mb-md-50 mb-lg-110"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _vm._t("default")], 2)])], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }